import { Box, Group, MultiSelect, Text } from "@mantine/core";

import { Product } from "../../../gql/__generated__/graphql";
import ProductCard from "../Cards/ProductCard";

interface ProductSelectorProps {
  products: Product[];
  selectedProductIds: string[];
  onChange: (selectedIds: string[]) => void;
  error?: string;
  maxProducts?: number;
}

function ProductSelector({
  products,
  selectedProductIds,
  onChange,
  error,
  maxProducts = 5,
}: ProductSelectorProps) {
  const selectedProducts = products.filter((product) =>
    selectedProductIds.includes(product.id)
  );

  const handleProductSelect = (selectedIds: string[]) => {
    // Limit to max products
    if (selectedIds.length <= maxProducts) {
      onChange(selectedIds);
    } else {
      onChange(selectedIds.slice(0, maxProducts));
    }
  };

  return (
    <Box>
      <MultiSelect
        label={`Select Products (max ${maxProducts})`}
        data={products.map((product) => ({
          value: product.id,
          label: product.name,
        }))}
        placeholder={`Select products (up to ${maxProducts})`}
        required
        maxValues={maxProducts}
        value={selectedProductIds}
        onChange={handleProductSelect}
        error={error}
      />

      {selectedProducts.length > 0 && (
        <Box mt="md">
          <Text size="sm" fw={500} mb="xs">
            Selected Products:
          </Text>
          <Group>
            {selectedProducts.map((product) => (
              <Box key={product.id} style={{ width: 200 }}>
                <ProductCard product={product} compact />
              </Box>
            ))}
          </Group>
        </Box>
      )}
    </Box>
  );
}

export default ProductSelector;
